import React, { useMemo } from "react";

import { useNavigation } from "./NavigationContext";
import { Navbar } from "./components/Navbar";

import { useCurrentUser } from "../../api/hooks/defs/auth";
import { useFeatureFlagQuery } from "../../hooks/useFeatureFlag";

import { hasVisibleTag } from "../../api/services/defs/navigation";

/**
 * Container component that fetches all data and passes to the presentational Navbar.
 * This is the component used in the actual app (with data fetching).
 */
const NavbarPortal = () => {
	const { data } = useCurrentUser();

	// Get all navigation state from context
	const { config, isLoading, mainNavItems, activeMainTab, activeNavItem, parentNavItem, currentSubNavItems } =
		useNavigation();

	// Module ownership for promotional ads comes off the nav config (see Navbar.tsx), not a
	// separate feature-flag query.
	const { value: hideBranchName } = useFeatureFlagQuery("ff-hide-branch-name", false);

	// Git branch chip logic (only show on dev environments)
	const gitBranch = useMemo(() => {
		if (hideBranchName) return null;

		const branch = (window as any).__GIT_BRANCH__ || "";
		if (!branch) return null;

		// Don't show on production domains
		const ignoreDomains = [
			"talent.performyard.com",
			"sandbox.talent.performyard.com",
			"localhost:8888",
			"demo.talent.performyard.com",
		];

		const currentDomain = window.location.host;
		const shouldDisplay = !ignoreDomains.includes(currentDomain);

		return shouldDisplay ? branch : null;
	}, [hideBranchName]);

	// Show nothing while loading (prevents flash of wrong nav)
	if (isLoading || !config) {
		return null;
	}

	return (
		<Navbar
			config={config}
			mainNavItems={mainNavItems}
			activeMainTab={activeMainTab}
			activeNavItem={activeNavItem}
			parentNavItem={parentNavItem}
			currentSubNavItems={currentSubNavItems}
			isDirectoryVisible={hasVisibleTag(config, "company", "directory")}
			userEmail={data?.me?.email}
			gitBranch={gitBranch}
		/>
	);
};

export default NavbarPortal;
